import { FC } from 'react';

import { iconTypes } from './config';

interface IProps {
  variant:
  | 'start'
  | 'stop'
  | 'pause'
  | 'logo'
  | 'randomize'
  | 'fullscreen'
  | 'settings-1'
  | 'settings-2'
  | 'cross'
  | 'arrow'
  | 'double-arrow'
  | 'voters'
  | 'reset'
  | 'approve';
}

const Icon: FC<IProps> = ({ variant }) => iconTypes[variant];

export default Icon;
